import React, { createRef } from "react";
import styles from "./style.module.css";

import NumberFormat from "react-number-format";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MagnifyingGlassThinIcon from "images/Magnifying Glass Light.svg";
import { faTimesCircle, faSearch } from "@fortawesome/free-solid-svg-icons";

export default class SearchInputDelayed extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = createRef();

    this.state = {
      searchTimer: undefined,
      value: props.value
    };
  }

  componentDidMount() {
    const { autoSelect } = this.props;
    if (autoSelect) {
      this.inputRef.current.focus();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
      this.setState({ value: this.props.value });
    }
  }

  handleSearch(value) {
    const { onChange, delay } = this.props;
    const { searchTimer } = this.state;
    if (searchTimer !== undefined) {
      clearTimeout(searchTimer);
    }
    const retDelay = delay ?? 1500;
    const inputTimer = setTimeout(() => onChange(value), retDelay);

    this.setState({ searchTimer: inputTimer, value: value });
  }
  handleClear() {
    const { onChange } = this.props;
    const { searchTimer } = this.state;
    clearTimeout(searchTimer);

    this.setState({ value: "", searchTimer: undefined });
    return onChange("");
  }
  render() {
    const { onChange, style, inputClass, iconClass, placeholder, responsive, isThinIcon, isPurpleFocusOutline } =
      this.props;

    return (
      <div className={responsive ? styles.searchBoxResponsive : styles.searchBox} style={style ? style : {}}>
        <div className={styles.searchIcon}>
          {isThinIcon ? (
            <img className={styles.searchIconThin} src={MagnifyingGlassThinIcon} />
          ) : (
            <FontAwesomeIcon icon={faSearch} />
          )}
        </div>
        <input
          ref={this.inputRef}
          className={(isPurpleFocusOutline ? styles.inputPurple : styles.input) + " " + (inputClass ? inputClass : "")}
          onChange={(event) => this.handleSearch(event.target.value)}
          placeholder={placeholder ?? "Search..."}
          value={this.state.value}
        />
        {this.state.value?.length > 0 && (
          <div className={styles.closeIcon + " " + (iconClass ? iconClass : "")} onClick={() => this.handleClear()}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </div>
        )}
      </div>
    );
  }
}
